import { withTheme } from 'styled-components'
import PageTitle from './PageTitle'

export default withTheme(PageTitle)
